export default "__VITE_ASSET__45fccd0e__"